import { ThemeColorScheme } from '@rebound/shared-models/retailer/retailer.model';

type ColorSchemeType = {
  v50: string;
  v100: string;
  v200: string;
  v300: string;
  v400: string;
  v500: string;
  v600: string;
  v700: string;
  v800: string;
  v900: string;
};

export const colorSchemeConfig: Record<string, ColorSchemeType> = {
  [ThemeColorScheme.Indigo]: {
    v50: '#EEF2FF',
    v100: '#E0E7FF',
    v200: '#C7D2FE',
    v300: '#A5B4FC',
    v400: '#818cf8',
    v500: '#6366F1',
    v600: '#4F46E5',
    v700: '#4338CA',
    v800: '#3730A3',
    v900: '#312e81',
  },
  [ThemeColorScheme.Rose]: {
    v50: '#FFF1F2',
    v100: '#FFE4E6',
    v200: '#FECDD3',
    v300: '#FDA4AF',
    v400: '#fb7185',
    v500: '#F43F5E',
    v600: '#E11D48',
    v700: '#BE123C',
    v800: '#9F1239',
    v900: '#881337',
  },
  [ThemeColorScheme.Orange]: {
    v50: '#FFF7ED',
    v100: '#FFEDD5',
    v200: '#FED7AA',
    v300: '#FDBA74',
    v400: '#fb923c',
    v500: '#F97316',
    v600: '#EA580C',
    v700: '#C2410C',
    v800: '#9A3412',
    v900: '#7c2d12',
  },
  [ThemeColorScheme.Green]: {
    v50: '#ECFDF5',
    v100: '#D1FAE5',
    v200: '#A7F3D0',
    v300: '#6EE7B7',
    v400: '#4ade80',
    v500: '#10B981',
    v600: '#059669',
    v700: '#047857',
    v800: '#065F46',
    v900: '#14532d',
  },
  [ThemeColorScheme.Blue]: {
    v50: '#EFF6FF',
    v100: '#DBEAFE',
    v200: '#BFDBFE',
    v300: '#93C5FD',
    v400: '#60a5fa',
    v500: '#3B82F6',
    v600: '#2563EB',
    v700: '#1D4ED8',
    v800: '#1E40AF',
    v900: '#1e3a8a',
  },
  [ThemeColorScheme.Neutral]: {
    v50: '#fafafa',
    v100: '#f5f5f5',
    v200: '#e5e5e5',
    v300: '#d4d4d4',
    v400: '#a3a3a3',
    v500: '#737373',
    v600: '#525252',
    v700: '#404040',
    v800: '#262626',
    v900: '#171717',
  },
  [ThemeColorScheme.Slate]: {
    v50: '#f8fafc',
    v100: '#f1f5f9',
    v200: '#e2e8f0',
    v300: '#cbd5e1',
    v400: '#94a3b8',
    v500: '#64748b',
    v600: '#475569',
    v700: '#334155',
    v800: '#1e293b',
    v900: '#0f172a',
  },
  [ThemeColorScheme.Red]: {
    v50: '#fef2f2',
    v100: '#fee2e2',
    v200: '#fecaca',
    v300: '#fca5a5',
    v400: '#f87171',
    v500: '#ef4444',
    v600: '#dc2626',
    v700: '#b91c1c',
    v800: '#991b1b',
    v900: '#7f1d1d',
  },
  [ThemeColorScheme.Purple]: {
    v50: '#faf5ff',
    v100: '#f3e8ff',
    v200: '#e9d5ff',
    v300: '#d8b4fe',
    v400: '#c084fc',
    v500: '#a855f7',
    v600: '#9333ea',
    v700: '#7e22ce',
    v800: '#6b21a8',
    v900: '#581c87',
  },
};
